import mustache from "mustache";
import { FieldConfig } from "../../definitions/form/FieldConfig";
import { IFormField } from "../../definitions/form/IFormField";

let FORM_FIELD_ID = 0;

export abstract class FormField<
  TConfig extends FieldConfig,
> implements IFormField {
  protected readonly _config: TConfig;
  protected readonly _formFieldId: string;

  constructor(config: TConfig) {
    this._config = config;
    FORM_FIELD_ID += 1;
    this._formFieldId = `form-field-${FORM_FIELD_ID}`;
  }

  protected _disposed: boolean = false;

  getId(): string {
    return this._formFieldId;
  }

  render(): string {
    return mustache.render(this.getTemplate(), this.getData());
  }

  dispose(): void {
    if (this._disposed) return;

    this.doDispose();
    this._disposed = true;
  }

  abstract getTemplate(): string;

  abstract getData(): unknown;

  abstract connect(): void;

  abstract doDispose(): void;

  abstract getError(): string | null;

  abstract showError(): void;

  abstract focus(): void;

  abstract disabled(): void;

  abstract enabled(): void;
}
